let notificationCallback;
export const registerNotificationCallback = (callback) => {
    notificationCallback = callback;
};
export const showNotification = (notification) => {
    if (notificationCallback) {
        return notificationCallback(notification);
    }
};
export const notif = (title, body, className = "", timeout = 30) => {
    const notification = {
        title,
        body,
        className,
        timeout
    };
    const balloon = showNotification(notification);
    return {
        close: () => balloon.close(notification),
    };
};
